import React, { useState } from 'react';
import './authPopup.scss';
import {request} from "../../../../api/request"; // Add your CSS for the popup styles here

const AuthPopup = ({ isOpen, onClose , id}) => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');

    const handleEmailChange = (e) => setEmail(e.target.value);
    const handlePasswordChange = (e) => setPassword(e.target.value);
    const [loginError, setLoginError] = useState('')
    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoginError('')
        await request
            .post(
                `/donors/auth/login/`,
                {
                    email,
                    password
                },
                {
                    headers: { "api-token": "p12378" }
                }
            )
            .then((res) => {
                console.log(res)
                if(res.status === 200){
                    const token = res.data?.token;
                    const page = res.data?.page;
                    const expiret_at = res.data?.expiret_at;
                    localStorage.setItem('dToken',token)
                    localStorage.setItem('page',page)
                    localStorage.setItem('expiret_at',expiret_at)
                    onClose()
                }
            })
            .catch((err,res) => {
                console.log(err)
                setLoginError(err.response?.data?.error || "An unknown error occurred.!");
            });
    };

    return (
        <div className={`auth-popup ${isOpen ? 'open' : ''}`}>
            <div className="auth-popup-content">
                <button className="close" onClick={onClose}>
                    &times;
                </button>
                <h2>Login</h2>
                <form onSubmit={handleSubmit}>
                    <div className="form-group">
                        <label htmlFor="email">Email</label>
                        <input
                            type="email"
                            id="email"
                            value={email}
                            onChange={handleEmailChange}
                            required
                        />
                    </div>
                    <div className="form-group">
                        <label htmlFor="password">Password</label>
                        <input
                            type="password"
                            id="password"
                            value={password}
                            onChange={handlePasswordChange}
                            required
                        />
                    </div>
                    <button type="submit" className="submit-btn">
                        Login
                    </button>
                </form>
                <p style={{color:"red"}}> {loginError}</p>
            </div>
        </div>
    );
};

export default AuthPopup;

